import styled from '@emotion/styled';
import { Button, Form, Select, notification } from 'antd';
import { useState } from 'react';
import { FaCrown, FaSave } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { ConnectedUserEntity } from '../../../../entities/ConnectedUserEntity';
import {
  AssetManagerType,
  PackType,
} from '../../../../redux/userStore/reducer';
import { ORANGE, PRIMARY, YELLOW } from '../../../../shared/colors';
import {
  addAbonnement,
  getAssetManagers,
  listAbonnement,
} from '../../../dashboard/network';

const FormShell = styled.div`
  margin-top: 14px;

  .subscription-card {
    border: 1px solid var(--mt-border);
    border-radius: 8px;
    padding: 14px;
    margin-bottom: 14px;
    background:
      linear-gradient(135deg, rgba(255, 79, 31, 0.1), transparent 44%),
      ${PRIMARY};
    color: #fff7e8;
  }

  .subscription-card span {
    color: ${YELLOW};
    font-family: Poppins-B;
    font-size: 11px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  .subscription-card h3 {
    margin: 5px 0;
    color: #fff7e8;
    font-family: Poppins-B;
    font-size: 20px;
  }

  .subscription-card p {
    margin: 0;
    color: rgba(255, 247, 232, 0.72);
  }

  .pack-option {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }

  .pack-option strong {
    font-family: Poppins-B;
  }

  .pack-option span {
    color: ${ORANGE};
    font-size: 12px;
  }

  .submit-row {
    display: flex;
    justify-content: flex-end;
    margin-top: 18px;
  }

  .submit-button {
    min-width: 190px;
    height: 42px;
    border: 0;
    border-radius: 999px;
    background: linear-gradient(135deg, ${ORANGE}, ${YELLOW});
    color: #07141c;
    font-family: Poppins-B;
  }
`;

export const AbonnementForm = ({
  setShowDrawer,
  settheasset,
  pack,
  getNewAsset,
}: {
  setShowDrawer: (b: boolean) => void;
  settheasset: AssetManagerType;
  pack: PackType[];
  getNewAsset: (part: AssetManagerType[]) => void;
}) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const connectedUser = new ConnectedUserEntity(
    useSelector((state: any) => state.userReducer).user,
  );

  return (
    <FormShell>
      <div className='subscription-card'>
        <span>Nouvelle souscription</span>
        <h3>{settheasset.nom || 'Client MoranjETrade'}</h3>
        <p>Sélectionnez le pack qui détermine les droits d’accès du client.</p>
      </div>
      <Form
        layout='vertical'
        form={form}
        labelCol={{ span: 20 }}
        wrapperCol={{ span: 25 }}
        onFinish={async (data) => {
          setIsLoading(true);
          data.manager = settheasset.id;
          await addAbonnement(connectedUser.id, data).then(
            ({ statusCode, data }) => {
              if (statusCode.toString()[0] === '2') {
                notification.success({
                  message: 'Abonnement souscrit',
                  description: "L'abonnement a été souscrit avec succès",
                });
                getAssetManagers().then(({ data: filterClient }) => {
                  filterClient.map((item: AssetManagerType) => {
                    item.abonnement = [];
                    listAbonnement(connectedUser.id, item.id).then(
                      ({ data }) => {
                        item.abonnement = data;
                      },
                    );
                    return item;
                  });
                  getNewAsset(filterClient);
                });
                setShowDrawer(false);
              } else {
                notification.error({
                  message: 'Erreur',
                  description: data.message,
                });
              }
              setIsLoading(false);
            },
          );
        }}
      >
        <Form.Item
          label='Pack sélectionné'
          name='pack'
          hasFeedback
          rules={[
            {
              required: true,
              message: '',
            },
          ]}
        >
          <Select placeholder='Sélectionnez un pack' suffixIcon={<FaCrown />}>
            {pack.map((pac) => (
              <Select.Option key={pac.id} value={pac.id}>
                <div className='pack-option'>
                  <strong>{pac.nom}</strong>
                  <span>{Number(pac.amount || 0).toLocaleString('fr-FR')} XAF</span>
                </div>
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item className='submit-row'>
          <Button
            htmlType='submit'
            loading={isLoading}
            className='submit-button'
            icon={<FaSave />}
          >
            Souscrire le pack
          </Button>
        </Form.Item>
      </Form>
    </FormShell>
  );
};
